const initialState = {
  isLoading: true,
  error: undefined,
  ratingCount: 0,
  averageRating: 0,
  ratingsByStars: [],
  ratingsByDate: [],
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_RATINGS_BY_STARS_REQUEST':
    case 'GET_RATINGS_BY_DATE_REQUEST': {
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    }

    case 'GET_RATINGS_BY_STARS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        error: undefined,
        averageRating: action.payload.average_rating,
        ratingCount: action.payload.rating_count,
        ratingsByStars:
          action.payload &&
          action.payload.ratings &&
          action.payload.ratings.slice(),
      };

    case 'GET_RATINGS_BY_DATE_SUCCESS':
      return {
        ...state,
        isLoading: false,
        error: undefined,
        ratingsByDate:
          action.payload &&
          (action.payload.ratings || []).map(({ average_stars, date }) => ({
            // eslint-disable-next-line camelcase
            averageStars: average_stars,
            date,
          })),
      };

    case 'GET_RATINGS_BY_STARS_FAILURE':
    case 'GET_RATINGS_BY_DATE_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: {
          status: action.status,
        },
      };

    default:
      return state;
  }
};

export default reducer;
